const mixpanel = require('mixpanel-browser');

mixpanel.init(process.env.REACT_APP_MIX_PANEL_TOKEN);

export default mixpanel;
